import type { GetEcoBlockResponse } from './eco-block'

export const getEcoBlockMock: GetEcoBlockResponse = {
  display: true,
  title: 'Reborn vs. brand new',
  description:
    'Here’s what you help prevent on average by choosing a reborn smartphone over a brand new one.',
  figures: [
    {
      type: 'co2',
      title: '171.1 lbs of CO2e',
      description: "That's like driving an SUV from NYC to Chicago.",
    },
    {
      type: 'e-waste',
      title: '6.3 oz of e-waste',
      description: 'That’s around the weight of a baseball.',
    },
    {
      type: 'raw-materials',
      title: '537.1 lbs of raw materials',
      description: "That's like 20 dogs digging in your yard for a week.",
    },
    {
      type: 'water',
      title: '20,341.2 gallons of water',
      description: "That's like running a faucet for 3 days",
    },
  ],
}
